import React from "react";
import { motion } from "framer-motion";
import { useTranslation, Trans } from "react-i18next";
import { ABOUT_IMAGE } from "@/lib/brand";

export const About = () => {
  const { t } = useTranslation();

  const STATS = [
    { n: "1–64", l: t("about.stats.sizes") },
    { n: "100%", l: t("about.stats.jeansFocus") },
    { n: t("about.stats.allAgesNumber"), l: t("about.stats.allAges") },
  ];

  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="bg-white border-y border-[#E5E5E0]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="font-body uppercase tracking-[0.28em] text-xs text-[#C86A3D] font-semibold">
            {t("about.eyebrow")}
          </span>
          <h2 className="font-display font-black tracking-tight text-4xl md:text-5xl text-[#1A1A1A] mt-5 leading-tight">
            <Trans
              i18nKey="about.title"
              components={{
                em: (
                  <span className="font-serif-editorial italic font-normal text-[#2A3563]" />
                ),
              }}
            />
          </h2>
          <p className="font-body text-[#1A1A1A]/70 mt-7 text-base md:text-lg leading-relaxed">
            {t("about.description")}
          </p>
          <blockquote className="font-serif-editorial italic text-xl md:text-2xl text-[#2A3563] mt-8 border-l-2 border-[#C86A3D] pl-6">
            {t("about.quote")}
          </blockquote>

          <div className="grid grid-cols-3 gap-6 mt-10">
            {STATS.map((s, i) => (
              <div key={i} data-testid={`about-stat-${i}`}>
                <div className="font-display font-black text-3xl text-[#2A3563]">
                  {s.n}
                </div>
                <div className="font-body text-sm text-[#1A1A1A]/60 mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 1.03 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="relative"
        >
          <div className="overflow-hidden rounded-sm border border-[#E5E5E0] aspect-[4/5]">
            <img
              src={ABOUT_IMAGE}
              alt={t("about.imageAlt")}
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-[#2A3563] text-white p-6 rounded-sm hidden md:block max-w-[220px]">
            <p className="font-display font-bold text-lg leading-snug">
              {t("about.highlight")}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
